import { render, staticRenderFns } from "./PhoneLink.vue?vue&type=template&id=5e2d76fe&functional=true&"
import script from "./PhoneLink.vue?vue&type=script&lang=js&"
export * from "./PhoneLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports